export default "__VITE_ASSET__CkfEU_QY__"